import React from "react";
import "./Dashboard.css";

/**
 * Skeleton loading component for SchoolAdminDashboard
 */
const SchoolAdminDashboardSkeleton = () => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className="p-0">
          <section>
            <div className="container-fluid">
              {/* Header Section Skeleton */}
              <div className="row mb-3 align-items-center">
                <div className="col-md-6 col-12">
                  <div
                    className="skeleton-box"
                    style={{
                      height: "28px",
                      width: "100%",
                      maxWidth: "200px",
                      marginBottom: "8px",
                    }}
                  ></div>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "16px",
                      width: "100%",
                      maxWidth: "300px",
                    }}
                  ></div>
                </div>
                <div className="col-md-6 col-12 text-start text-md-end mt-2 mt-md-0">
                  <div
                    className="skeleton-box d-inline-block me-2"
                    style={{
                      height: "44px",
                      width: "120px",
                      borderRadius: "5px",
                    }}
                  ></div>
                  <div
                    className="skeleton-box d-inline-block"
                    style={{
                      height: "44px",
                      width: "120px",
                      borderRadius: "5px",
                    }}
                  ></div>
                </div>
              </div>

              {/* Stats Cards Skeleton */}
              <div className="row g-3 mb-4">
                {/* Total Students Card */}
                <div className="col-lg-6 col-md-6">
                  <div className="stat-card stat-card-purple">
                    <div className="skeleton-box stat-card-icon-skeleton"></div>
                    <div className="stat-card-content h-100">
                      <div
                        className="skeleton-box"
                        style={{
                          height: "14px",
                          width: "100%",
                          maxWidth: "100px",
                          marginBottom: "8px",
                        }}
                      ></div>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "38px",
                          width: "60px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Total Teachers Card */}
                <div className="col-lg-6 col-md-6">
                  <div className="stat-card stat-card-green h-100">
                    <div className="skeleton-box stat-card-icon-skeleton"></div>
                    <div className="stat-card-content">
                      <div
                        className="skeleton-box"
                        style={{
                          height: "14px",
                          width: "100px",
                          marginBottom: "8px",
                        }}
                      ></div>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "38px",
                          width: "60px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Total Quests Card */}
                <div className="col-lg-6 col-md-6">
                  <div className="stat-card stat-card-orange h-100">
                    <div className="skeleton-box stat-card-icon-skeleton"></div>
                    <div className="stat-card-content">
                      <div
                        className="skeleton-box"
                        style={{
                          height: "14px",
                          width: "100px",
                          marginBottom: "8px",
                        }}
                      ></div>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "38px",
                          width: "60px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Passing Percentage Card */}
                <div className="col-lg-6 col-md-6">
                  <div className="stat-card stat-card-blue h-100">
                    <div className="skeleton-box stat-card-icon-skeleton"></div>
                    <div className="stat-card-content">
                      <div
                        className="skeleton-box"
                        style={{
                          height: "14px",
                          width: "100%",
                          maxWidth: "180px",
                          marginBottom: "8px",
                        }}
                      ></div>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "42px",
                          width: "80px",
                          borderRadius: "5px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quiz Attempts Section Skeleton */}
              <fieldset className="quiz-attempts-fieldset">
                <legend className="quiz-attempts-legend">
                  <div
                    className="skeleton-box"
                    style={{
                      height: "18px",
                      width: "120px",
                    }}
                  ></div>
                </legend>
                <div className="quiz-attempts-content">
                  <div className="quiz-attempts-controls">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="skeleton-box"
                        style={{
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                        }}
                      ></div>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "16px",
                          width: "120px",
                        }}
                      ></div>
                    </div>
                    <div
                      className="skeleton-box"
                      style={{
                        height: "44px",
                        width: "90px",
                        borderRadius: "5px",
                      }}
                    ></div>
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="skeleton-box"
                        style={{
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                        }}
                      ></div>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "16px",
                          width: "120px",
                        }}
                      ></div>
                    </div>
                  </div>
                  <div
                    className="skeleton-box"
                    style={{
                      height: "44px",
                      width: "140px",
                      borderRadius: "5px",
                    }}
                  ></div>
                </div>
              </fieldset>
            </div>
          </section>
        </div>
      </div>

      <style>{`
        @keyframes skeleton-pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        .skeleton-box {
          background-color: #e0e0e0;
          border-radius: 4px;
          animation: skeleton-pulse 1.5s ease-in-out infinite;
          max-width: 100%;
        }
        .stat-card-icon-skeleton {
          width: 56px;
          height: 56px;
          border-radius: 10px;
          flex-shrink: 0;
        }
        /* Responsive styles for skeleton */
        @media (max-width: 768px) {
          .stat-card-icon-skeleton {
            width: 48px;
            height: 48px;
          }
        }
        @media (max-width: 576px) {
          .stat-card-icon-skeleton {
            width: 40px;
            height: 40px;
          }
        }
      `}</style>
    </>
  );
};

export default SchoolAdminDashboardSkeleton;
